export function getFirstName(name: string): string {
    if (typeof name !== "string") {
        return "";
    }
    const [first] = name.split(" ");
    return first;
}
